import { useState } from "react";
import { faqs } from "@/mocks/faq";

export default function FaqSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <section id="faq" className="w-full bg-background-100 py-14 md:py-20">
      <div className="mx-auto w-full max-w-7xl px-4 md:px-6">
        <div className="grid grid-cols-1 gap-10 lg:grid-cols-[0.8fr_1.2fr] lg:gap-14">
          <div>
            <p className="eyebrow">
              <i className="ri-question-answer-line" aria-hidden="true"></i>
              常见问题
            </p>
            <h2 className="section-title mt-4">关于围观，你可能想问</h2>
            <p className="mt-4 font-body text-sm leading-relaxed text-foreground-600 md:text-base">
              如果这里没有你要的答案，可以在「关于我们」页面留言，我们会把高频问题补进这一栏。
            </p>
          </div>

          <div className="flex flex-col gap-3">
            {faqs.map((faq, index) => {
              const isOpen = openIndex === index;
              return (
                <div
                  key={faq.question}
                  className={`overflow-hidden rounded-lg border bg-background-50 transition-colors duration-200 ${
                    isOpen ? "border-primary-300" : "border-background-200"
                  }`}
                >
                  <h3>
                    <button
                      type="button"
                      onClick={() => setOpenIndex(isOpen ? null : index)}
                      className="flex w-full items-center justify-between gap-4 px-4 py-4 text-left md:px-6 md:py-5"
                      aria-expanded={isOpen}
                    >
                      <span className="font-heading text-sm font-bold text-foreground-950 md:text-base">
                        {faq.question}
                      </span>
                      <span
                        className={`flex h-7 w-7 shrink-0 items-center justify-center rounded-full transition-colors duration-200 ${
                          isOpen ? "bg-primary-500 text-background-50" : "bg-background-200 text-foreground-600"
                        }`}
                      >
                        <i className={`${isOpen ? "ri-subtract-line" : "ri-add-line"} text-base`} aria-hidden="true"></i>
                      </span>
                    </button>
                  </h3>
                  {isOpen && (
                    <div className="px-4 pb-5 md:px-6">
                      <p className="font-body text-sm leading-relaxed text-foreground-600">{faq.answer}</p>
                    </div>
                  )}
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}